<template>
  <VTDropdownPill
    :disable-save-button="!isSkipFrequencyValid()"
    :is-enabled="!disabled"
    @confirm="saveChanges"
    @clear="reset"
    @on-click-outside="discardChanges"
  >
    <template #dropDownHeader>
      <VTPill label="Skip frequency">
        <template #values>
          <div :class="$style.wrapper">
            <div>
              <div :class="$style.row">
                <div :class="[$style.column, $style.timeText]">
                  {{ props.modelValue }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </VTPill>
    </template>
    <template #dropdown-content>
      <div :class="$style.dropdownContainer">
        <p>Skip frequency</p>
        <InputNumber v-model="skipFrequency" mode="decimal" :max="999" :min="0" />
        <div v-if="!isSkipFrequencyValid()">
          <p :class="$style.invalidText">Please enter a valid integer number between 0 and 999.</p>
        </div>
        <div :class="$style.row">
          <p :class="$style.hintText">Offer is shown after the following number of triggering events</p>
        </div>
      </div>
    </template>
  </VTDropdownPill>
</template>

<script setup lang="ts">
import type { Ref } from "vue";
import { ref } from "vue";
import VTDropdownPill from "@/components/VTDropdownPill";
import VTPill from "@/components/VTPill";
import InputNumber from "primevue/inputnumber";

const props = defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(["update"]);
const skipFrequency: Ref<number> = ref(props.modelValue);
const saveChanges = () => {
  emit("update", skipFrequency.value);
};
const reset = () => {
  emit("update", 0);
  skipFrequency.value = 0;
};
const discardChanges = () => {
  skipFrequency.value = props.modelValue;
};
const isSkipFrequencyValid = () => skipFrequency.value <= 999 && skipFrequency.value >= 0;
</script>
<style module>
.wrapper {
  display: flex;
  flex-direction: row;
  overflow-x: hidden;
  align-items: center;
  gap: 8px;
}

.dropdownContainer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}

.row {
  display: flex;
  position: relative;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
}

.column {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.timeText {
  font-weight: 700;
  font-size: 14px;
}

.hintText {
  color: #909298;
  font-size: 12px;
  font-weight: 400;
  text-align: start;
}

.invalidText {
  color: #f56b6b;
  margin: 0;
  padding: 0;
}
</style>
